<template>
  <div class="memoryBank">
    <el-container>
      <el-header>
        <div class="memory_header_left">
          <el-button class="createMemoryBank" type="primary" @click="createMemoryBank">
            {{$t('memoryBankV2.newmemory')}}</el-button>
          <el-button class="merge" type="primary" @click="handlermerge">
            {{$t('memoryBankV2.merge')}}</el-button>
          <el-button class="duplicateremoval" type="primary" @click="handlerduplicatere">
            {{$t('memoryBankV2.duplicateremoval')}}
          </el-button>
        </div>
        <!-- 头部--右边筛选 -->
        <div class="memory_header_right">
          <div class="search-box">
            <el-input type="text" v-model="formLabelAlign.name" @input="changeinput"
                      :placeholder="$t('memoryBankV2.searchTermName')" size="small" clearable
                      @clear="handlerclear" @keyup.enter.native="handlerSerach">

            </el-input>
            <el-button class="search-btn " @click="handlerSerach">
            </el-button>
          </div>
          <el-popover width="200" trigger="click" popper-class="popover-screen" placement="bottom">
            <h3>{{$t('common.filter')}}</h3>
            <div class="filter" :class="{'filter_en':$i18n.locale==='en'}" slot="reference">
              {{$t('common.filter')}}</div>
            <ul>
              <li>
                <p class="Language_p">{{$t('memoryBankV2.languageDirectionNoColon')}}</p>
                <el-select :popper-append-to-body="false" popper-class="corpus-select-poper"
                           size="small" v-model="formLabelAlign.lang_desc"
                           :placeholder="$t('memoryBankV2.pleaseChoose')">
                  <template v-for="(item, index) in languageTwain">
                    <el-tooltip :disabled="$i18n.locale==='zh'" :key="index" class="item"
                                effect="dark"
                                :content="$langCase[item.sourceLang] + ' — ' + $langCase[item.targetLang]"
                                placement="left-start">
                      <el-option style="text-align:center;"
                                 :label="$i18n.locale==='zh'?item.langDesc.replace('>',' — '):$langCase[item.sourceLang] + ' — ' + $langCase[item.targetLang]"
                                 :value="item.langDesc"></el-option>
                    </el-tooltip>
                  </template>
                </el-select>
              </li>
              <li>
                <p class="territory_P">{{$t('memoryBankV2.domainNoColon')}}</p>
                <el-select v-model="formLabelAlign.domain_code" size="small"
                           :placeholder="$t('memoryBankV2.pleaseChoose')">
                  <el-option v-for="(item, index) in territory" :key="index" :label="item.name"
                             :value="item.code"></el-option>
                </el-select>
              </li>
              <!-- 操作 -->
              <li class="btn">
                <el-button @click="clearSearch">{{$t('common.reset')}}</el-button>
                <el-button type="primary" @click="handlerFilete">{{$t('common.Search')}}</el-button>
              </li>
            </ul>
          </el-popover>
        </div>
      </el-header>
      <!-- 表格 -->
      <div class="bottom_form">
        <el-table height="calc(100% - 82px)" ref="multipleTable" :data="list" border
                  @sort-change="sortChange">
          <!-- 序号列 -->
          <el-table-column type="index" :index="indexMethod" :label="$t('memoryBankV2.number')"
                           width="57" align="center" :show-overflow-tooltip="true" />
          <!-- 名称列 -->
          <el-table-column prop="name" :label="$t('memoryBankV2.libraryName')" align="left"
                           :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <p class="name_active" @click="handlerDetail(row)">{{ row.name }}</p>
            </template>
          </el-table-column>
          <!-- 语言对列 -->
          <el-table-column prop="langDesc" :label="$t('memoryBankV2.languageDirectionNoColon')"
                           align="center" :show-overflow-tooltip="true">
            <template
                      slot-scope="{ row }">{{$i18n.locale === 'zh' ? row.langDesc.replace('>'," — ") : $langCase[row.sourceLang] + ' — ' + $langCase[row.targetLang]}}</template>
          </el-table-column>
          <!-- 领域列 -->
          <el-table-column prop="domainName" :label="$t('memoryBankV2.domainNoColon')"
                           align="center" :show-overflow-tooltip="true">
            <template
                      slot-scope="{ row }">{{$i18n.locale === 'zh' ? row.domainName : $domainCase[row.domainCode]}}</template>
          </el-table-column>
          <!-- 句对数列 -->
          <el-table-column prop="sentCount" :label="$t('memoryBankV2.sentenceNum')" align="center"
                           :show-overflow-tooltip="true" />
          <!-- 创建人列 -->
          <!-- <el-table-column prop="creator" :label="$t('memoryBankV2.createPerson')" align="center"
                           :show-overflow-tooltip="true" /> -->
          <!-- 创建时间列 -->
          <el-table-column prop="createTime" :label="$t('memoryBankV2.createTime')" align="center"
                           min-width="110px" sortable="custom" :show-overflow-tooltip="true" />
          <!-- 操作列 -->
          <el-table-column :label="$t('memoryBankV2.operation')" align="center" width="224">
            <template slot-scope="{row}">
              <div class="iconList">
                <!-- 查看 -->
                <el-tooltip class="item" effect="dark" :content="$t('common.view')" placement="top">
                  <i class="icon-view" @click="handlerDetail(row)" />
                </el-tooltip>
                <!-- 编辑 -->
                <el-tooltip class="item" effect="dark" :content="$t('memoryBankV2.edit')"
                            placement="top">
                  <i class="icon-edit" @click="updateMember(row)" />
                </el-tooltip>
                <!-- 下载 -->
                <el-tooltip class="item" effect="dark" :content="$t('memoryBankV2.downLoad')"
                            placement="top">
                  <i class="icon-down" @click="downMemory(row)" />
                </el-tooltip>
                <!-- 上传 -->
                <el-tooltip class="item" effect="dark" :content="$t('memoryBankV2.upload')"
                            placement="top">
                  <i class="icon-upload" @click="handleUpload(row)" />
                </el-tooltip>
                <!-- 删除 -->
                <el-tooltip class="item" effect="dark" :content="$t('memoryBankV2.delete')"
                            placement="top">
                  <i class="icon-delete" @click="handleDelete(row)" />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!--列表表格结束-->

        <!-- 列表表格分页开始 -->
        <div class="pagination">
          <el-pagination background :pager-count="5" :current-page.sync="params.page"
                         :page-sizes="[15, 30, 60, 120]" :page-size.sync="params.rows"
                         :total="total" layout="prev, pager,next,sizes"
                         @current-change="handleCurrentChange" @size-change="handleSizeChange" />
        </div>
        <!--列表表格分页结束-->
      </div>
    </el-container>
    <!-- 新建弹窗 -->
    <addcorpus-dialog :bankType="bankType" @handlerClose="colseAddcorpus"
                      @handlerdetermine="handlerdetermine" :addcorpusVisible="addcorpusVisible"
                      :langList="langList" :optionList="optionList">
    </addcorpus-dialog>
    <!-- 去重 -->
    <duplicateremoval-dialog ref="duplicateremoval" :bankType="bankType"
                             :duplicateremovalVisible="duplicateremovalVisible"
                             @handleClose="closeduplicateremoval" @tohandle="tohandle"
                             @handle="handle" @closepending="closepending">

    </duplicateremoval-dialog>
    <!-- 合并弹窗 -->
    <mergecorpus-dialog :bankType="bankType" :mergeVisible="mergeVisible"
                        @handlerclose="closeMergecorpus" @handleConfirm="handleConfirmMerge"
                        :languageTwain="languageTwain" :territory="territory">
    </mergecorpus-dialog>
    <!-- 下载 -->
    <DownloadCorpus-dialog :corpusDetailInfo="rowInfo" :dialogVisible="downloadVisible"
                           :bankType="bankType" @handleClose="closeDown">
    </DownloadCorpus-dialog>
    <!-- 删除-->
    <DeleteCorpus :bankType="bankType" :dialogVisible="deleteVisible" @handleClose="closeDelete"
                  @handleConfirm="handledeleteConfirm" />
    <!-- 编辑弹窗 -->
    <EditCorpus :dialogVisible="updateVisible" :bankType="bankType" :corpusDetailInfo="rowInfo"
                :options="options" @handleClose="closeUpdate" @handleConfirm="sureUpdate">
    </EditCorpus>
    <!-- 上传弹窗 -->
    <UploadCorpus :bankType="bankType" title="upload" :dialogVisible="uploadVisible"
                  :corpusDetailInfo="rowInfo" @handleClose="closeupload" @handleConfirm="isUpload"
                  :accept="accept" />
  </div>
</template>

<script>
import { getLang, getOptionList } from "@/services/memoryBank";
import {
  getMemory,
  languageDirections,
  getTerritory,
  querySentCount,
  delMemory,
} from "@/services/memoryBank";
//新建记忆库
import addcorpusDialog from "../components/addcorpusDialog.vue";
//去重弹窗
import duplicateremovalDialog from "../components/duplicateremovalDialog"
//合并
import mergecorpusDialog from "../components/mergecorpusDialog"
//删除
import DeleteCorpus from "../components/deleteDialog";
//编辑
import EditCorpus from "../components/editCorpus";
//下载
import DownloadCorpusDialog from "../components/downloadCorpusDialog"
//上传
import UploadCorpus from "../components/corpusDetailUploadDialog";

export default {
  name: "corpusmemoryBank",
  components: {
    addcorpusDialog,
    mergecorpusDialog,
    DownloadCorpusDialog,
    DeleteCorpus,
    EditCorpus,
    UploadCorpus,
    duplicateremovalDialog
  },
  data() {
    return {
      bankType: "memory", //辨别 记忆库
      list: [], //主页面列表数据
      languageTwain: [], //合并传入的语言方向
      territory: [], //合并传入的领域
      params: {
        page: 1, //页码
        rows: 15, //每页条数
        filter: {},
        sort: {
          create_time: "desc"
        }, //排序
      },
      total: 0, //总条数
      formLabelAlign: {
        //表单搜索
        domain_code: "",
        lang_desc: "",
        name: ""
      },
      options: {},//传入的编辑数据
      duplicateremovalVisible: false,//去重弹窗
      mergeVisible: false, //合并弹窗控制
      addcorpusVisible: false, //新建记忆库的开关
      updateVisible: false, //编辑记忆库的开关
      deleteVisible: false, //单个删除记忆库开关
      downloadVisible: false, //下载的开关
      uploadVisible: false, //控制首页上传展示隐藏,
      langList: [], //语言表
      optionList: [], //领域数据
      rowInfo: {}, //点击编辑获取的数据
      rowId: null, //每一行的id
      timer: null, //定时器
      accept: '.xlsx, .txt, .tmx, .zip',
      deletType: 'single',
    };
  },
  watch: {},
  mounted() {
    this.getMemoryList(this.page);
    this.getLanguage();
    this.getlangList();
    this.acquireTerritory();
    const data = JSON.parse(localStorage.getItem("userInfo")).lastSelectCompany;
    this.companyCode = data.code;
  },
  methods: {
    //去重
    handlerduplicatere(row) {
      if (this.list.length === 0) {
        return false
      }
      this.duplicateremovalVisible = true;
      this.$refs.duplicateremoval.getduplicateremoval();
    },
    //关闭去重
    closeduplicateremoval() {
      this.duplicateremovalVisible = false;
      this.pollingQuerySentCount();
    },
    closepending() {
      this.pollingQuerySentCount();
    },
    //去处理
    tohandle() {
      this.duplicateremovalVisible = false;
    },
    handle() {
      this.pollingQuerySentCount();
    },
    //搜索
    handlerSerach() {
      this.params.page = 1;
      Reflect.set(this.params.filter, "name", this.formLabelAlign.name)
      this.getMemoryList();
    },
    //清除搜索
    handlerclear() {
      this.formLabelAlign.name = "";
      Reflect.set(this.params.filter, "name")
      this.getMemoryList();
    },
    // 清空筛选并重新拉取列表
    clearSearch() {
      this.formLabelAlign.domain_code = "";
      this.formLabelAlign.lang_desc = "";
      Reflect.set(this.params.filter, "domain_code");
      Reflect.set(this.params.filter, "lang_desc")
      this.getMemoryList();
    },
    //筛选
    handlerFilete() {
      this.params.page = 1;
      if (this.formLabelAlign.lang_desc) {
        this.params.filter.lang_desc = this.formLabelAlign.lang_desc
      }
      if (this.formLabelAlign.domain_code) {
        this.params.filter.domain_code = this.formLabelAlign.domain_code
      }
      this.getMemoryList();
    },
    //不能以空格开头
    changeinput() {
      this.formLabelAlign.name = this.formLabelAlign.name.replace(/^\s*/g, '');
    },
    //打开合并弹窗
    handlermerge() {
      this.mergeVisible = true;
    },
    //关闭合并弹窗
    closeMergecorpus() {
      this.mergeVisible = false;
    },
    //点击合并
    handleConfirmMerge() {
      this.mergeVisible = false;
      this.clearSearch();
      this.pollingQuerySentCount();
    },
    indexMethod(index) {
      if (index < 9) {
        index += 1;
        return "0" + index;
      } else {
        return index + 1;
      }
    },
    //分页获取记忆库列表
    async getMemoryList() {
      const res = await getMemory(this.params);
      if (res.success && res.resultCode == 1) {
        this.list = res.list;
        this.total = res.totalRows || 0;
        //删除优化
        if (this.params.page > 1 && this.list.length < 1) {
          this.params.page - 1;
          this.getMemoryList();
        }
      } else {
        this.$message.closeAll();
        this.$message.error(res.errorDesc);
      }
    },
    //排序
    sortChange({ prop, order }) {
      if (order == "descending") {
        order = "desc"; //降序
      } else if (order == "ascending") {
        order = "asc"; //升序
      } else {
        order = "desc";
      }
      if (prop == "createTime") {
        this.params.sort = { create_time: order };
        this.getMemoryList();
      }
    },
    //页面切换
    handleCurrentChange(newPage) {
      this.params.page = newPage;
      this.getMemoryList();
    },
    //每页数量改变时触发
    handleSizeChange(size) {
      this.params.rows = size;
      this.getMemoryList();
    },
    //获取语言方向
    async getLanguage() {
      let params = {
        companyCode: this.companyCode
      };
      const res = await languageDirections(params);
      if (res.success && res.resultCode == 1) {
        this.languageTwain = res.result;
      }
    },
    //获取领域
    async acquireTerritory() {
      let params = {
        companyCode: this.companyCode
      };
      const res = await getTerritory(params);
      if (res.success && res.resultCode == 1) {
        this.territory = res.result;
        if (this.$i18n.locale === "en") {
          this.territory = [...res.result];
          this.territory.forEach(
            item => (item.name = this.$domainCase[item.code])
          );
        }
      }
    },
    //点击编辑的方法
    updateMember(row) {
      this.options = [...this.langList, ...this.optionList]
      this.rowInfo = JSON.parse(JSON.stringify(row));
      this.updateVisible = true;
      this.getlangList();
    },
    getlangList() {
      getLang({ type: "1" }).then(res => {
        this.langList = res.result;
      });
      getOptionList({ dataType: "trans_domain" }).then(res => {
        if (res.success) {
          this.optionList = res.result;
        }
      });
    },
    //点击添加记忆库触发的方法
    createMemoryBank() {
      this.addcorpusVisible = true;
      this.getlangList()
    },
    //取消添加
    colseAddcorpus() {
      this.addcorpusVisible = false;
    },
    //确定添加
    handlerdetermine() {
      this.addcorpusVisible = false;
      this.params.page = 1;
      this.clearSearch();
      // 更新语言方向
      this.getLanguage();
      // 更新领域
      this.acquireTerritory();
      //轮询获取新添加的文件sendCount
      this.pollingQuerySentCount();
    },
    //关闭编辑
    closeUpdate() {
      this.updateVisible = false;
    },
    //确认编辑
    sureUpdate() {
      this.getMemoryList();
      // 更新语言方向
      this.getLanguage();
      // 更新领域
      this.acquireTerritory();
      this.updateVisible = false;
    },
    // 跳转详情页
    handlerDetail(row) {
      this.$router.push({
        name: 'corpusmemoryDetail',
        query: {
          key: this.$Base64.encode(JSON.stringify({
            row,
            langList: this.langList,
            optionList: this.optionList
          }))
        }
      });
    },
    //开启删除弹窗
    handleDelete(row) {
      this.rowInfo = row
      this.deleteVisible = true;
    },
    //关闭删除弹窗
    closeDelete() {
      this.deleteVisible = false;
    },
    //确认删除
    async handledeleteConfirm() {
      this.deleteVisible = false;
      const { success } = await delMemory({ id: this.rowInfo.id })
      if (success) {
        this.$message.closeAll();
        this.$message.success(this.$t("memoryBankV2.deleteSuccess"));
      }
      this.getMemoryList();
    },
    //首页上传
    handleUpload(row) {
      this.uploadVisible = true;
      this.rowInfo = row;
      console.log(this.rowInfo)
    },
    //上传隐藏
    closeupload() {
      this.uploadVisible = false;
    },
    //确定上传
    isUpload() {
      this.uploadVisible = false;
      this.$message.success(this.$t("memoryBankV2.uploadSuccess"))
      this.$nextTick(() => {
        this.pollingQuerySentCount(this.rowInfo.id);
      })
    },
    // 轮询 SentCount
    pollingQuerySentCount(rowId = null) {
      const self = this;
      let status = null; //状态值
      let sentCount = null; //数量值
      let pollingRowId = null; //轮询的哪一行数据id
      // 如果定时器存在，就清除定时器
      if (!!self.timer) {
        clearInterval(self.timer);
      }
      self.timer = setInterval(async () => {
        let list = JSON.parse(JSON.stringify(this.list)) || []; //列表
        let params = { idList: [] }; // 接口传参idList
        // 如果传的rowId就是上传文件，直接push
        if (rowId) {
          params.idList.push(rowId);
        } else {
          //否则为创建记忆库，将list第一个数据添加
          pollingRowId = list[0].id;
          params.idList.push(pollingRowId);
        }
        let { result, success } = await querySentCount(params);
        if (!success) return;
        // 调用成功将 状态值|数量 ,赋值
        status = result[0].status;
        sentCount = result[0].sentCount;
        if (status === 1) {
          this.getMemoryList();
          clearInterval(self.timer);
          self.timer = null;
          return;
        }
      }, 3000);
    },
    //下载记忆库文件
    downMemory(row) {
      if (row.sentCount === 0) {
        this.$message.closeAll();
        this.$message.error(this.$t("memoryBankV2.sentCountMemory"));
        return;
      } else {
        this.downloadVisible = true;
        this.rowInfo = row;
      }
    },
    //关闭下载弹窗
    closeDown() {
      this.downloadVisible = false;
    },
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>

<style lang="less" scoped>
.popover-screen {
  h3 {
    font-size: 16px;
    font-weight: 600;
    color: #454545;
  }
  ul {
    width: 200px;
    li + li {
      color: #454545;
      margin-top: 12px;
    }
    li {
      margin-top: 12px;
      p {
        margin-bottom: 2px;
      }
      /deep/.el-select-dropdown {
        width: 210px;
      }
      /deep/.el-select {
        width: 100%;
        .el-input {
          width: 100%;
          .el-input__inner {
            height: 32px;
            line-height: 32px;
          }
        }
      }
      &:nth-child(1) {
        /deep/.el-input__inner {
          height: 32px;
          line-height: 32px;
        }
        .el-input__icon {
          line-height: 32px;
        }
      }
      .el-button + .el-button {
        margin-left: 20px;
      }
      .el-button {
        padding: 0 20px;
        height: 32px;
        line-height: 32px;
      }
      .el-button--default {
        color: #0078fc;
        border: 1px solid #0078fc;
      }
    }
    .btn {
      text-align: center;
    }
  }
}
</style>
